import React from "react";
import Title from "../layouts/Title";
import CounterCard from "./CounterCard";

const Metrics = () => {
  return (
    <section
      id="metrics"
      className="w-full py-20 border-b-[1px] border-b-cardBg"
    >
      <div className="max-w-screen-xl mx-auto px-4">
        <Title title="Key Achievements" />
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-10">
          <CounterCard
            value={35}
            suffix="%"
            title="Feature Adoption Increase"
          />
          <CounterCard value={500} suffix="%" title="Delivery Velocity Boost" />
          <CounterCard value="14-16" title="Features Shipped Annually" />
          <CounterCard value="4+" title="Years of Product Leadership" />
        </div>
      </div>
    </section>
  );
};

export default Metrics;
